import axiosInstance from '../../../../config/axiosInstance';
const UserService = {
    async getAllUsers(redirectCallback, Start, PageSize, searchQuery, sortColumn, sortDirection, SearchColumns) {
        try {
            Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "";
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Setup/GetAllUsers?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async fetchUserByTeam(redirectCallback, TeamID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/Setup/fetchUsersByTeamID?ClientID=${CompanyID}&TeamID=${TeamID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async DeleteUsers(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteUser?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UpdateColor(ID, Color, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/UpdateColor`, {
                params: {
                    ID: ID,
                    Color: Color
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async IsEmailExist(redirectCallback, email) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/Setup/IsEmailExist?email=${email}&ClientID=${CompanyID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async IsCompanyEmailExist(redirectCallback, email) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/Setup/IsCompanyEmailExist?email=${email}&ClientID=${CompanyID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async fetchUsersByID(redirectCallback) {
        try {

            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Setup/fetchUsersByID?UserID=${UserID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async UserDetailByEmail(Email, ClientID) {
        try {

            const response = await axiosInstance.get(`/Setup/UserDetailByEmail?Email=${Email}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {

                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async IsMultipleCompanies(Email) {
        try {

            const response = await axiosInstance.get(`/Setup/IsMultipleCompanies?Email=${Email}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {

                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async AllDiaryUsers(redirectCallback) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/Setup/AllDiaryUsers?CompanyID=${CompanyID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async AllowedDiaryUsers(redirectCallback) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Setup/AllowedDiaryUsers?CompanyID=${CompanyID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },
    async GetUserNotification(redirectCallback) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Setup/GetUserNotification?CompanyID=${CompanyID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching users:', error);
            throw error;
        }
    },

};

export default UserService;